import { Button } from '@ophelos/ui/components/button';
import { useSidebar } from '@ophelos/ui/components/sidebar';
import { ChevronsRight } from 'lucide-react';
import { OphelosIcon } from '../branding/ophelos-icon';
import { OphelosLogo } from '../branding/ophelos-logo';
import { HubLink } from './HubNavLink';

/** Renders the Ophelos logo (expanded) or icon (collapsed) for sidebar headers */
export function SidebarLogo() {
  const { toggleSidebar, state } = useSidebar();
  if (state === 'collapsed') {
    return (
      <div className="group relative flex items-center justify-center w-full">
        <OphelosIcon className="w-auto h-7 text-gray-900/50 dark:text-[#F5F4F2] opacity-100 group-hover:opacity-0 transition-opacity duration-300" />
        <Button
          variant="ghost"
          size="icon-xs"
          onClick={toggleSidebar}
          className="absolute top-0 hover:bg-sidebar-accent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        >
          <ChevronsRight className="size-4 text-muted-foreground" />
        </Button>
      </div>
    );
  }

  return (
    <HubLink to="/" className="flex items-start">
      <OphelosLogo className="w-auto h-13 py-2.5 text-gray-900/50 dark:text-[#F5F4F2]" />
    </HubLink>
  );
}
